module.exports = __webpack_public_path__ + "static/scale-model-of-memphis-tennessee-87db6058ffc6b0aef6a57aa9d3c7815a.png";